import { render, staticRenderFns } from "./ConfirmationUseStatus.vue?vue&type=template&id=2ffe92e1&"
import script from "./ConfirmationUseStatus.js?vue&type=script&lang=js&"
export * from "./ConfirmationUseStatus.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports